import styled from 'styled-components'
import { Card } from 'antd'

export const StyledPage = styled.div`
  padding: 24px;
  background: #f0f2f5;
  min-height: calc(100vh - 64px);
`

export const StyledCard = styled(Card)`
  margin-bottom: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;

  .ant-card-body {
    padding: 24px;
  }

  .ant-table-thead > tr > th {
    background: #fafafa;
    font-weight: 600;
  }

  .ant-table-tbody > tr:hover > td {
    background: #f5f5f5;
  }

  .ant-btn-link {
    padding: 0;
    height: auto;
  }
`